module.exports = __webpack_public_path__ + "static/background-2cdc0853973d930451e6e8dc53ec0f44.jpg";